import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { QuickPanelComponent } from 'src/app/layout/components/quick-panel/quick-panel.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from 'src/app/Shared/material.module';

@NgModule({
  declarations: [QuickPanelComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatTooltipModule,
    MaterialModule,
  ],
  exports: [QuickPanelComponent],
})
export class QuickPanelModule {}
